import Backbone from 'backbone';
import { setApiUrl } from 'backboneExtensions';
import { isAutomatedTestMode, isDevelopmentMode } from 'env';

/** __THE_DOUBLE_UNDERSCORE_VARIABLES__ are replaced by rsbuild at build time. */
declare const __APP_VERSION__: string;
declare const __FEATURE_FLAGS__: Record<string, boolean> | undefined;

setApiUrl(Backbone.Model, '');
setApiUrl(Backbone.Collection, '');

export const APP_VERSION = isAutomatedTestMode({ detectUnitTestsOnly: true })
  ? 'test'
  : __APP_VERSION__;

window.FEATURE_FLAGS = isAutomatedTestMode({ detectUnitTestsOnly: true })
  ? undefined
  : __FEATURE_FLAGS__;

/**
 * Only exposed on window so developers can access it in the console, please use `APP_VERSION` in code
 */
window.ARDOQ_BUILD_VERSION = APP_VERSION;

export const RESOURCE_BASE_URL =
  isDevelopmentMode() || window.CDN_URL === ''
    ? window.location.origin
    : `${window.CDN_URL}/`;
